import React, { memo } from 'react'

import { EVENT_SOURCE } from 'Pods/SearchPage/Shared/Tracking/constants'
import { FilterTrackingProvider } from 'Pods/SearchPage/Shared/Tracking/FilterTracking'

import AssetTypeToggle from './Components/AssetTypeToggle/AssetTypeToggle'
import ClearFiltersButton from './Components/ClearFiltersButton/ClearFiltersButton'
import DatePublished from './Components/DatePublished/DatePublished'
import FileFormat from './Components/FileFormat/FileFormat'
import License from './Components/License/License'
import MoreFilters from './Components/MoreFilters/MoreFilters'
import Price from './Components/Price/Price'
import Quality from './Components/Quality/Quality'
import ResultsCount from './Components/ResultsCount/ResultsCount'
import Sorting from './Components/Sorting/Sorting'

function MainFilters() {
  return (
    <FilterTrackingProvider eventSource={EVENT_SOURCE.FILTER_BAR}>
      <div className="search-page__main-filters">
        <div className="main-filters__primary">
          <AssetTypeToggle />
          {/* Price is the most used filter, so it leads the row wherever its slot is visible. */}
          <div className="main-filters__slot main-filters__slot--md">
            <Price />
          </div>
          <div className="main-filters__slot main-filters__slot--md">
            <FileFormat />
          </div>
          <div className="main-filters__slot main-filters__slot--lg">
            <Quality />
          </div>
          <div className="main-filters__slot main-filters__slot--lg">
            <License />
          </div>
          <div className="main-filters__slot main-filters__slot--xl">
            <DatePublished />
          </div>
          <MoreFilters />
          <ClearFiltersButton />
        </div>
        <div className="main-filters__secondary">
          <Sorting />
          <ResultsCount />
        </div>
      </div>
    </FilterTrackingProvider>
  )
}

export default memo(MainFilters)
